<script>
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
const mapClientName = {
  IPAD: "iPad端版本：",
  MAC: "Mac端版本：",
  WINDOWS: "Windows端版本：",
  ANDROID: "安卓端版本："
};
export default {
  data() {
    const ROLE_ADMIN = localStorage.getItem("roles").indexOf("ROLE_ADMIN") > -1;
    return {
      tableData: [],
      ROLE_ADMIN,
      num: undefined,
      editVersion: false,
      checkInput: false,
      // WindowsVserion: {
      //   first: undefined,
      //   second: undefined,
      //   third: undefined
      // },
      // MacVserion: {
      //   first: undefined,
      //   second: undefined,
      //   third: undefined
      // },
      // AndroidVserion: {
      //   first: undefined,
      //   second: undefined,
      //   third: undefined
      // },
      // iPadVserion: {
      //   first: undefined,
      //   second: undefined,
      //   third: undefined
      // },
      clientVersion: {
        windows: "1.0.1",
        mac: "1.0.1",
        android: "1.0.1",
        ipad: "1.0"
      },
      clientVersionArr: [],
      tempClientVersionArr: []
    };
  },
  computed: {
    hasDiff() {},
    WindowsVserion() {
      const versionArr = this.clientVersion.windows.split(".");
      let result = [undefined, undefined, undefined];
      versionArr.forEach((item, index) => {
        if (item !== undefined) {
          result[index] = parseInt(item);
        }
      });
      return result;
    },
    MacVserion() {
      const versionArr = this.clientVersion.mac.split(".");
      let result = [undefined, undefined, undefined];
      versionArr.forEach((item, index) => {
        if (item !== undefined) {
          result[index] = parseInt(item);
        }
      });
      return result;
    },
    AndroidVserion() {
      const versionArr = this.clientVersion.android.split(".");
      let result = [undefined, undefined, undefined];
      versionArr.forEach((item, index) => {
        if (item !== undefined) {
          result[index] = parseInt(item);
        }
      });
      return result;
    },
    iPadVserion() {
      if (this.clientVersion.ipad) {
      }
      const versionArr = this.clientVersion.ipad.split(".");
      let result = [undefined, undefined, undefined];
      versionArr.forEach((item, index) => {
        if (item !== undefined) {
          result[index] = parseInt(item);
        }
      });
      return result;
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const clientVersion = await this.$http.getRecentlyClientVersion();
      if (clientVersion && clientVersion.length > 0) {
        const newClientVersion = clientVersion.map(o => {
          o.versionArr = o.version.split(".");
          o.title = mapClientName[o.clientSystem];
          return o;
        });
        this.clientVersionArr = cloneDeep(newClientVersion);
        this.tempClientVersionArr = cloneDeep(newClientVersion);
      }
    },
    onCancel() {
      this.editVersion = false;
      this.clientVersionArr = cloneDeep(this.tempClientVersionArr);
    },
    async onSave() {
      this.checkInput = false;
      let requireCheck = false;
      this.clientVersionArr.forEach(item => {
        item.versionArr.forEach(o => {
          if (o !== 0 && !o) {
            requireCheck = true;
          }
        });
      });

      if (!requireCheck) {
        const updateData = this.clientVersionArr.map(item => {
          return {
            clientSystem: item.clientSystem,
            version: item.versionArr.join("."),
            url: item.url
          };
        });
        console.log(updateData);
        const result = await this.$http.updateClientVersion(updateData);
        if (result) {
          this.$message.success("保存成功！");
        }
        this.editVersion = false;
        this.loadData();
      } else {
        this.checkInput = true;
        this.$message.warning("请完成必填项！");
      }
    }
  }
};
</script>
<template>
  <div class="visionClientVersionIndex">
    <el-row
      :gutter="24"
      v-for="(item ,index) in clientVersionArr"
      :key="item.clientSystem + index"
      class="versionRow"
    >
      <el-col v-if="editVersion" :span="24">
        <span class="clientTitle">{{item.title}}</span>
        <el-input-number
          :class="(item.versionArr[0] !== 0 && !item.versionArr[0]) && checkInput ? 'versionNumberInput requiredInput' : 'versionNumberInput'"
          size="medium"
          v-model="item.versionArr[0]"
          :controls="false"
          :precision="0"
          :step="1"
          :max="256"
        ></el-input-number>
        <span style="vertical-align: top;">·</span>
        <el-input-number
          :class="(item.versionArr[1] !== 0 && !item.versionArr[1]) && checkInput ? 'versionNumberInput requiredInput' : 'versionNumberInput'"
          size="medium"
          v-model="item.versionArr[1]"
          :controls="false"
          :precision="0"
          :step="1"
          :max="256"
        ></el-input-number>
        <span style="vertical-align: top;">·</span>
        <el-input-number
          :class="(item.versionArr[2] !== 0 && !item.versionArr[2]) && checkInput ? 'versionNumberInput requiredInput' : 'versionNumberInput'"
          size="medium"
          v-model="item.versionArr[2]"
          :controls="false"
          :precision="0"
          :step="1"
          :max="256"
        ></el-input-number>
        <el-input class="versionDownloadInput" size="medium" v-model="item.url" type="textarea"></el-input>
      </el-col>

      <el-col v-else :span="24">
        <span class="clientTitle">{{item.title}}</span>
        <span class="clientTitle">{{item.version}}</span>
        <span v-if="ROLE_ADMIN">{{item.url}}</span>
      </el-col>
    </el-row>
    <el-row :gutter="24" class="versionRow" v-if="ROLE_ADMIN">
      <el-col :offset="3" :span="12" v-if="editVersion">
        <el-button type="primary" class="operationButton" @click="onSave" size="mini">保存</el-button>
        <el-button type="primary" class="operationButton" @click="onCancel" size="mini">取消</el-button>
      </el-col>
      <el-col :offset="3" :span="12" v-else>
        <el-button type="primary" class="operationButton" @click="editVersion = true" size="mini">编辑</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss">
@import "@/css/color.scss";

.visionClientVersionIndex {
  padding-left: 30px;
  padding-top: 35px;
  .versionRow {
    width: 850px;
    display: block;
    line-height: 35px;
    margin-bottom: 30px;
    font-size: 14px;
    font-weight: 400;
    color: rgba(89, 94, 122, 1);
    .versionNumberInput {
      width: 55px;
      height: 36px;
      margin-left: 5px;
      margin-right: 5px;
      vertical-align: top;
    }
    .clientTitle {
      width: 120px;
      display: inline-block;
      vertical-align: top;
    }
    .versionDownloadInput {
      display: inline-block;
      width: 400px;
      margin-left: 15px;
    }
    .requiredInput {
      .el-input {
        border: 1px solid red;
      }
    }
    .operationButton {
      //   margin: 10px;
      font-size: 14px;
      margin-right: 20px;
      width: 60px;
      height: 36px;
      background: rgba(0, 193, 222, 1);
      border-color: #00c1de;
      border-radius: 4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/visionClientVersion/index.vue